import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Boat Hire Vilamoura · Private Crewed Yacht · Morningstar";
const DESC = "Boat hire in Vilamoura aboard Morningstar — a fully crewed private yacht for up to 18 guests. Half-day, sunset, Benagil and full-day from Marina de Vilamoura.";
const PATH = "/boat-hire-vilamoura";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.boatHireVilamoura;

export const Route = createFileRoute("/boat-hire-vilamoura")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Boat Hire · Vilamoura · Algarve",
        title: "Boat hire in Vilamoura aboard ",
        titleAccent: "Morningstar.",
        sub: "A fully crewed private yacht for up to 18 guests, departing Marina de Vilamoura. Skipper, deckhand, fuel, drinks and tapas — all included. No licence needed.",
        ctaPrimary: "View hire options",
        ctaSecondary: "Request a quote",
      }}
      pageContent={CONTENT.en}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "boat hire vilamoura, boat hire vilamoura portugal, boat rental vilamoura, yacht hire vilamoura, boat hire algarve",
      altPath: { en: PATH, pt: "/pt/aluguer-de-barco-vilamoura" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Boat Hire from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Boat Hire Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.en.faqs)) },
      ],
    }),
});
